import type { File } from "$lib/wasm/file";
import { PreviewCanvas } from "svelte-pixel-editor-wasm";

const previewCanvases: Record<number, { canvas: PreviewCanvas; width: number; height: number }> =
    {};

export function getCanvas(file: File) {
    const id = file.id!;
    const entry = previewCanvases[id];
    if (entry && entry.width === file.width && entry.height === file.height) {
        return entry.canvas;
    }

    entry?.canvas.free();
    const canvas = PreviewCanvas.new(file.width, file.height);
    previewCanvases[id] = { canvas, width: file.width, height: file.height };
    return canvas;
}
